import VueMatomo from 'vue-matomo';
import { getMatomoSiteId } from '@/helpers/deployment';

export const plugin = {
    name: 'matomo',
    pluginProperties: {
    },

    install (Vue) {
        Vue.use(VueMatomo, {
          //  router:  this.$router,
            host: 'https://taideart.matomo.cloud/',
            enableHeartBeatTimer: true,
            siteId: getMatomoSiteId() // Replace with your site ID in Matomo Analytics
          });
    }
};

export default plugin;

